/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class HomeService {
  private homeUrl = environment.host + '/home/';
  private homeRecentUrl = environment.host + '/home/recent';
  public homeData: any;
  public homeMetaData = new EventEmitter<any>();
  private marketurl: string = environment.host + '/market?tabType=' + 'marketsregions/homepage';
  private calendarUrl: string = environment.host + '/calendarDefinition?companyCode=';

  constructor(private http: HttpClient) {}

  public getHomeDetails() {
    return this.http.get(this.homeUrl.toString()).toPromise();
  }

  // getHomeRecentDetails() {
  //   // if (args && args.hideLoader) {
  //   //   const headers = new Headers();
  //   //   headers.append('hideLoader', 'true');
  //   //   // const options = new RequestOptions({ headers: headers });
  //   //   // return this.httpp.get(this.homeRecentUrl.toString(), options).toPromise();
  //   //   return this.http.get(this.homeRecentUrl.toString(),  {observe: 'body'}).toPromise();
  //   // } else {
  //   //   return this.http.get(this.homeRecentUrl.toString()).toPromise();
  //   // }
  //    return this.http.get(this.homeRecentUrl.toString()).toPromise();
  // }

  public setRecentHomeData(homeData: any) {
    this.homeData = homeData;
    if (homeData) {
      this.homeMetaData.emit(homeData);
    }
  }

  public getRecentHomeData() {
    return this.homeData;
  }

  public getAllMarkets() {
    return this.http.get(this.marketurl.toString()).toPromise();
  }

  public getCalendarDefinitionTabType(companyCode: any) {
    const calUrl = this.calendarUrl + companyCode + '&tabType=planperiodview/homepage';
    return this.http.get(calUrl).toPromise();
  }
}
